var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoFullDark = function SvgLogoFullDark(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127,
    height: 16,
    fill: "none",
    viewBox: "0 0 127 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint9_linear_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint10_linear_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint11_radial_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint12_radial_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint13_radial_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint14_radial_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint15_linear_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint16_radial_5857_34273)",
    fillRule: "evenodd",
    d: "m13.22 12.64 7.49-7.511c.1-.1.269-.08.34.043l4.018 6.804a1.07 1.07 0 0 0 1.971-.745l-1.47-7.665a2.605 2.605 0 0 0-4.115-1.597.243.243 0 0 1-.339-.045A4.8 4.8 0 0 0 18.501.152c-1.6-.43-3.48.071-4.663 1.257L6.348 8.92c-.1.1-.268.08-.34-.043L1.99 2.074a1.07 1.07 0 0 0-1.97.745l1.47 7.664a2.605 2.605 0 0 0 4.114 1.597c.106-.08.26-.06.34.046a4.8 4.8 0 0 0 2.613 1.772c1.783.478 3.391.018 4.663-1.257m-6.043-2.098a.216.216 0 0 0-.033.263l.005.009a3.081 3.081 0 0 0 4.835.61l7.895-7.916a.216.216 0 0 0 .034-.263l-.005-.01a3.081 3.081 0 0 0-4.835-.61zm17.204-3.967c.045.238-.276.36-.4.15l-1.723-2.918a.216.216 0 0 1 .034-.263l.102-.103a.872.872 0 0 1 1.472.451zm-21.704.9c-.046-.239.275-.36.399-.151l1.723 2.918a.216.216 0 0 1-.033.263l-.102.103a.872.872 0 0 1-1.473-.45z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F4EB",
    d: "M80.513 3.441c-.03.183.185.301.324.178.794-.71 2.294-.986 2.958-1.02a36 36 0 0 1 1.553-.035c.264 0 .479.214.479.478v.842c0 .158.128.286.286.286h1.027a.287.287 0 0 0 .286-.286v-1.13c0-.103.087-.19.19-.19h1.224c.105 0 .19.086.19.19l.002.002v1.223c0 .105-.085.19-.19.19h-1.127a.287.287 0 0 0-.287.287v1.035c0 .158.129.286.287.286h.84c.263 0 .477.215.477.479v2.499a.477.477 0 0 1-.478.477h-.84a.287.287 0 0 0-.286.287v.847a.48.48 0 0 1-.478.478h-.836a.287.287 0 0 0-.287.286v.834a.48.48 0 0 1-.478.478c-.005 0-.718.032-1.549-.018-1.292-.08-2.281-.484-3.135-1.15V16h-1.721V2.563h1.72zm-7.287-.933c2.79 0 4.645 1.838 4.646 4.703 0 .249-.01.502-.046.758h-7.439v.035c.057 1.826 1.207 3.007 2.931 3.007 1.346 0 2.331-.704 2.634-1.884l.017-.071h1.752l-.022.113c-.406 2.069-2.08 3.406-4.268 3.406-2.902 0-4.852-2.01-4.852-5.003 0-1.454.445-2.704 1.285-3.611v-.002c.844-.911 2.005-1.451 3.361-1.451zm-25.672 0c2.79 0 4.647 1.838 4.647 4.703 0 .248-.01.5-.046.757h-7.438v.035c.056 1.826 1.207 3.007 2.931 3.007 1.346 0 2.33-.704 2.633-1.884l.019-.071h1.751l-.022.113c-.406 2.069-2.08 3.406-4.268 3.406-2.902 0-4.852-2.01-4.852-5.003 0-1.454.444-2.704 1.285-3.611l-.001-.001c.843-.911 2.005-1.451 3.36-1.451zm15.881 0c2.331 0 3.908 1.335 4.324 3.558l.021.114h-1.809l-.015-.076c-.277-1.253-1.203-2.033-2.54-2.033-1.786 0-2.988 1.473-2.988 3.519 0 2.045 1.2 3.418 2.987 3.419 1.28 0 2.222-.724 2.52-1.939l.018-.072h1.826l-.02.112c-.395 2.168-2.025 3.463-4.362 3.463-2.879 0-4.74-1.956-4.74-4.983 0-1.464.458-2.719 1.325-3.63s2.06-1.452 3.453-1.452M93.667.596c.104 0 .19.085.19.19v1.589c0 .104.086.191.19.191h2.915c.105 0 .192.086.192.192V3.98a.193.193 0 0 1-.192.192h-2.913a.19.19 0 0 0-.19.19v6.201c0 .158.127.287.285.288l2.728.002a.286.286 0 0 0 .286-.286V9.435c0-.106.086-.192.192-.192l1.227.002a.19.19 0 0 1 .19.189v1.226a.19.19 0 0 1-.191.192h-1.131a.29.29 0 0 0-.286.287v.846a.477.477 0 0 1-.478.478h-1.825v-.004h-.52a.477.477 0 0 1-.478-.478v-.846a.287.287 0 0 0-.286-.286h-1.13a.19.19 0 0 1-.191-.192V4.36a.19.19 0 0 0-.19-.191h-1.226a.19.19 0 0 1-.19-.19V2.755c0-.104.084-.19.19-.19h1.225c.105 0 .19-.087.19-.192V.786a.19.19 0 0 1 .191-.19zm12.669 1.967c.105 0 .192.086.192.19v1.228a.193.193 0 0 1-.192.192h-2.737a.286.286 0 0 0-.286.286v.842a.48.48 0 0 1-.479.478h-.939a.19.19 0 0 0-.19.19v6.302a.193.193 0 0 1-.193.192h-1.225a.19.19 0 0 1-.192-.191V2.755a.193.193 0 0 1 .192-.192h1.225c.106 0 .193.087.193.192V3.98c0 .105.086.192.19.192h1.13a.287.287 0 0 0 .287-.286v-.845a.48.48 0 0 1 .479-.479h2.546zm8.171 0c.264 0 .479.213.479.478v.94c0 .105.086.19.191.19h1.19c.125.001.227.103.227.228v6.23a.23.23 0 0 1-.227.228h-1.095a.286.286 0 0 0-.286.287v1.127a.193.193 0 0 1-.192.192h-5.369a.48.48 0 0 1-.479-.479v-.935a.19.19 0 0 0-.191-.192h-.938a.48.48 0 0 1-.479-.478V4.65a.48.48 0 0 1 .479-.478h.843a.286.286 0 0 0 .286-.286V2.754c0-.105.086-.191.191-.191zm5.098 0c.106 0 .192.086.193.19V3.98c0 .106.086.192.191.192h1.129a.287.287 0 0 0 .287-.286v-1.13c0-.105.085-.192.191-.192h1.224c.105 0 .192.087.192.192v1.13c0 .158.129.286.287.286h1.125c.127 0 .249.05.338.14l1.328 1.444a.48.48 0 0 1 .139.338v6.178a.19.19 0 0 1-.191.19h-1.226a.19.19 0 0 1-.191-.19v-6.3a.193.193 0 0 0-.193-.19h-1.224a.193.193 0 0 1-.192-.192V4.455a.287.287 0 0 0-.287-.286h-1.033a.286.286 0 0 0-.286.286V5.59a.193.193 0 0 1-.192.191h-1.225a.19.19 0 0 0-.191.192v6.299a.193.193 0 0 1-.193.19h-1.225a.19.19 0 0 1-.191-.19V2.755c0-.105.086-.191.192-.191zM38.413 0a4.09 4.09 0 0 1 4.085 4.085 4.09 4.09 0 0 1-4.085 4.084h-3.63v4.291h-1.72L33.057 0zm16.406 3.446c-.03.174.18.281.305.156h-.001c.611-.615 1.443-1.038 2.231-1.039l.906.001V4.3h-.905a2.377 2.377 0 0 0-2.377 2.377v5.782h-1.723V2.563h1.723zm54.412.726a.286.286 0 0 0-.286.286v4.596c0 .105.087.191.192.191h.939c.264 0 .478.215.478.48v.942a.193.193 0 0 0 .192.191h3.953a.286.286 0 0 0 .286-.286V5.974a.19.19 0 0 0-.191-.192h-.939a.48.48 0 0 1-.478-.48v-.938a.19.19 0 0 0-.191-.191l-.001-.001zM83.734 4.17c-1.832.04-3.193 1.206-3.193 3.339h-.001c0 2.163 1.364 3.262 3.266 3.335.84.019 1.816 0 1.83 0a.19.19 0 0 0 .19-.19V9.71c0-.264.214-.479.478-.479h.836a.286.286 0 0 0 .286-.286v-2.88a.286.286 0 0 0-.286-.287h-.836a.48.48 0 0 1-.477-.478v-.94a.19.19 0 0 0-.192-.191c-.015 0-1.22-.036-1.9 0m-36.162-.118c-1.403 0-2.567 1.078-2.751 2.445h5.522c-.179-1.495-1.207-2.445-2.771-2.445m25.672 0c-1.403 0-2.566 1.078-2.75 2.445h5.521c-.178-1.495-1.207-2.445-2.771-2.445m-38.46-2.33v4.725h3.629a2.365 2.365 0 0 0 2.362-2.362 2.365 2.365 0 0 0-2.361-2.362z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5857_34273",
    x1: 22.604,
    x2: 26.375,
    y1: 4.412,
    y2: 2.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5857_34273",
    x1: 21.279,
    x2: 15.714,
    y1: 5.556,
    y2: 10.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5857_34273",
    x1: 11.128,
    x2: 8.237,
    y1: 12.342,
    y2: 9.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5857_34273",
    x1: 4.527,
    x2: 6.993,
    y1: 5.976,
    y2: 8.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5857_34273",
    x1: 4.527,
    x2: -2.246,
    y1: 5.976,
    y2: 0.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5857_34273",
    x1: 2.801,
    x2: -0.319,
    y1: 6.96,
    y2: 8.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5857_34273",
    x1: 9.331,
    x2: 6.212,
    y1: 8.544,
    y2: 5.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.419,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5857_34273",
    x1: 21.581,
    x2: 20.029,
    y1: 2.503,
    y2: 3.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5857_34273",
    x1: 22.542,
    x2: 21.037,
    y1: 4.274,
    y2: 5.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5857_34273",
    x1: 28.773,
    x2: 21.055,
    y1: 15.214,
    y2: 5.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5857_34273",
    x1: 28.773,
    x2: 20.983,
    y1: 15.214,
    y2: 4.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5857_34273",
    x1: 17.978,
    x2: 9.62,
    y1: 6.743,
    y2: 12.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.067,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_5857_34273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.36726 -5.66373 5.66369 .36726 17.523 1.345)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.543,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_5857_34273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-130.321 10.29 -3.224)scale(2.79106)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_5857_34273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-130.527 10.604 -3.064)scale(3.41806)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_5857_34273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-41.92 10.678 -19.26)scale(2.6904)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_5857_34273",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(3.4487 3.34828 -9.44089 9.72419 11.505 13.101)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#F8F4EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#F8F4EB",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoFullDark);
export default ForwardRef;